export class TwilioChatEngineError extends Error {
  public constructor(message: string, cause: unknown) {
    if (cause instanceof Error) {
      let causeMessage: string = '/ Cause: ' + cause.message;
      Object.entries(cause).forEach((entry: [string, unknown]) => {
        if (!(entry[0] in ['message', 'stack'])) {
          causeMessage += `, ${entry[0]}=${JSON.stringify(entry[1])}`;
        }
      });
      causeMessage += '.';

      super(message + causeMessage);
      this.name = cause.name;
      this.stack = cause.stack;
    } else {
      super(message);
    }
  }
}
